module.exports = __webpack_public_path__ + "static/img/4.87ccfbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/eng/4.png
// module id = BHYM
// module chunks = 0